import CrudCustom from '../../../libs/custom/CrudCustom';

let PajakTerutangGunggungService = new CrudCustom('/pajak-terutang-digunggung');
export default PajakTerutangGunggungService;

